<h1 mat-dialog-title [attr.data-cy]="'dsfadsfad_h1_1_4_'">F&uuml;r andere Mandanten &uuml;bernehmen?</h1>
<div mat-dialog-content>
    <p>Sollen die &Auml;nderungen f&uuml;r die folgenden Mandanten &uuml;bernommen werden?</p>
    <ul style="list-style-type: none; padding-left: 0;">
        <li *ngFor="let m of mandanten; let i = index" [attr.data-cy]="'dsfadsfad_li_1_5_' + i" style="margin-bottom: 16px;">
            <div style="display: flex; align-items: center; gap: 8px;">
                <mat-checkbox
                    [formControl]="mandantCtrl[m.mandant_id]"
                    (change)="updateSelectedMandanten()"
                    [attr.data-cy]="'dsfadsfad_mat-checkbox_1_3_'"
                    >{{ m.bezeichnung }}</mat-checkbox
                >
            </div>
            <div *ngIf="mandantCtrl[m.mandant_id].value" 
                 style="margin-left: 32px; margin-top: 8px;">
                <mat-form-field *ngIf="showBezeichnung && buttonText !== 'Löschen'" appearance="outline" style="font-size: 0.875rem; width: 100%; max-width: 600px; margin-bottom: 8px;">
                    <mat-label>Bezeichnung</mat-label>
                    <input
                        matInput
                        type="text"
                        [formControl]="bezeichnungCtrl[m.mandant_id]"
                        placeholder="Artikelbezeichnung"
                    />
                </mat-form-field>
                <div *ngIf="showPrices" 
                     style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; max-width: 600px;">
                    <mat-form-field appearance="outline" style="font-size: 0.875rem;">
                        <mat-label>Einkaufspreis (€)</mat-label>
                        <input
                            matInput
                            type="number"
                            step="0.01"
                            [formControl]="einzelpreisCtrl[m.mandant_id]"
                            placeholder="0.00"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="font-size: 0.875rem;">
                        <mat-label>Marge (%)</mat-label>
                        <input
                            matInput
                            type="number"
                            step="0.01"
                            [formControl]="margeCtrl[m.mandant_id]"
                            placeholder="20.00"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="font-size: 0.875rem;">
                        <mat-label>Verkaufspreis (€)</mat-label>
                        <input
                            matInput
                            type="number"
                            step="0.01"
                            [formControl]="verkaufspreisCtrl[m.mandant_id]"
                            placeholder="0.00"
                        />
                    </mat-form-field>
                </div>
            </div>
        </li>
    </ul>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()" [attr.data-cy]="'dsfadsfad_button_1_0_'">Abbrechen</button>
    <span class="spacer"></span>
    <button
        mat-flat-button
        color="accent"
        (click)="saveForSelected()"
        [disabled]="selectedMandantenIds?.length < 1"
        [attr.data-cy]="'dsfadsfad_button_2_0_'"
        >{{ buttonText }}</button
    >
</div>
